<template>
    <div class="container">
        <div class='c-title'>全部分类</div>
        <div class='category'>
          <div class='cg_left' infinite-infinite-scroll="true">
            <template v-if="firstClassCategoryList.length > 0">
              <div
                class="category_item"
                v-for="(item, index) in firstClassCategoryList"
                :key="index"
                @click="switchListTab(index, item.Key)"
                :class="{'cate-list': true, 'cg_active':currentIndex === index}">
                    {{item.Value}}
              </div>
            </template>
            <template v-else>
              <div
                class="category_item lazy-list"
                v-for="index in 5"
                :key="index">
                  <div class='cg_item'></div>
              </div>
            </template>
          </div>
          <div class='cg_right' infinite-scroll-disabled="true">
            <div class='cg_list'>
              <template v-if="secondClassCategoryList.length > 0">
                <div class='cg_list_1'
                  v-for="(item, index) in secondClassCategoryList"
                  :key="index"
                  @click="entoSearchResult(item.Name)">
                  <div class='cg_img'>
                      <img :src='item.LogoUrl' />
                  </div>
                  <div class='cg_txt'>{{item.Name}}</div>
                </div>
              </template>
              <template v-else>
                <div
                  class='cg_list_1 lazy-list'
                  v-for="(item,index) in 8"
                  :key="index">
                  <div class='cg_img'></div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <return-home></return-home>
    </div>
</template>

<script>
import { firstCategoryLeve, secondCategoryLeve } from '@/api/sort'
import returnHome from '@/components/smartComponent/returnHome'
import { Indicator, Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      currentIndex: 0,
      firstClassCategoryList: [],
      secondClassCategoryList: []
    }
  },
  components: {
    returnHome
  },
  computed: {
    ...mapGetters([
      'getSortIndex'
    ])
  },
  mounted () {
    this.currentIndex = this.getSortIndex
    Indicator.open({
      text: '加载中',
      spinnerType: 'triple-bounce'
    })
    firstCategoryLeve().then(res => {
      Indicator.close()
      this.firstClassCategoryList = res
      this.fetchSecondCategoryLeve(res[this.currentIndex].Key)
    }).catch(res => {
      Indicator.close()
      if (res.ErrMsg) {
        Toast(res.ErrMsg)
      }
    })
  },
  methods: {
    ...mapMutations([
      'SET_SORT_INDEX'
    ]),
    fetchSecondCategoryLeve (key) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      secondCategoryLeve({ level1ID: key }).then(res => {
        Indicator.close()
        this.secondClassCategoryList = res
      }).catch(res => {
        Indicator.close()
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      })
    },
    switchListTab (index, key) {
      this.SET_SORT_INDEX(index)
      this.currentIndex = index
      this.fetchSecondCategoryLeve(key)
    },
    entoSearchResult (val) {
      this.$router.push({ name: 'searchResult', query: { search: val } })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'searchResult') {
      this.SET_SORT_INDEX(0)
    }
    next()
  }
}
</script>

<style scoped>
.container{
    width:100%;
    height: 100%;
    background: #f5f5f5;
}
.c-title{
  border-top: 1px solid #f2f2f2;
  padding:10px 15px;
  text-align: center;
  background: #fff;
  margin-bottom:8px;
}
.category{
  display: flex;
  flex-direction: row;
  height: calc(100% - 50px);
}
.cg_left{
  width:95px;
  height: 100%;
  margin-right: 8px;
  text-align: center;
  overflow-y: scroll;
}
.cg_left .category_item{
  background: #fff;
  height:50px;
  line-height: 50px;
  font-size: 14px;
}
.cg_left .cg_active{
  background: #f2f2f2 !important;
}
.cg_right{
  width: calc( 100% - 100px);
  height: 100%;
  overflow-y: scroll;
}
.cg_title{
  height: 45px;
  line-height: 45px;
  border-bottom:1px solid #f2f2f2;
  width: 100%;
}
.cg_list{
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  color: #999;
}
.cg_list_1{
  width:25.33%;
  text-align: center;
  background: #fff;
  margin: 10px 4% 10px 4%;
}
.cg_img{
  width:75%;
  height: 0;
  padding-bottom: 90%;
  margin: 0 auto;
  position: relative;
}
.cg_img img{
  width: 100%;
  position: absolute;
  top:0;
  left: 0;
}
.cg_txt{
  font-size: 13px;
  color: #999;
}
.lazy-list .cg_img{
  background: #f2f2f2;
  width:75%;
}
.lazy-list .cg_item{
  height: 70%;
  width: 80%;
  background: #f2f2f2;
  display: inline-block;
  vertical-align: middle;
}
</style>
